import type { TRuleWithTheme } from '@ackee/fela';

import topRightDivider from '../../../../../static/images/blog/authorDivider.svg';

export const container: TRuleWithTheme = () => ({
    textAlign: 'center',
});

export const title: TRuleWithTheme = () => ({
    marginTop: 0,
    marginBottom: 0,
    textAlign: 'left',
});

export const categoryTitle: TRuleWithTheme = () => ({
    marginTop: '4.375rem',
    marginBottom: '3rem',
    width: 'fit-content',
});

export const categoryTitleNumber: TRuleWithTheme = () => ({
    display: 'inline',
});

export const role: TRuleWithTheme = ({ theme: { colors } }) => ({
    color: colors.lightGrey,
    marginBottom: '1.5rem',
});

export const description: TRuleWithTheme = ({ theme: { colors } }) => ({
    marginBottom: '1rem',
});

export const authorContainer: TRuleWithTheme = () => ({
    display: 'flex',
    gap: 48,
    marginBottom: 48,
    paddingTop: 200,
});

export const authorWrapper: TRuleWithTheme = () => ({
    position: 'relative',
    backgroundImage: `url(${topRightDivider})`,
    backgroundPosition: 'top right',
    backgroundRepeat: 'no-repeat',
});

export const authorTextContainer: TRuleWithTheme = () => ({
    maxWidth: 965,
});

export const authorImage: TRuleWithTheme = () => ({
    width: 268,
    height: 268,
});

export const otherLangTitle: TRuleWithTheme = () => ({
    width: 'fit-content',
    textDecoration: 'none',
    textTransform: 'uppercase',
    letterSpacing: 3,
    fontSize: 14,
});

export const link: TRuleWithTheme = () => ({
    textDecoration: 'none',
});
